import { applyMiddleware, createStore } from "redux";
//import thunk from 'redux-thunk';
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension/logOnlyInProduction";  //For Dev
import reducer from "./reducers/index";

// const store = createStore(reducer, undefined, applyMiddleware(thunk));  //For Prod

//For Dev
const store = createStore(reducer, undefined, composeWithDevTools(applyMiddleware(thunk)));
export default store;
